
import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function DifferentialsSection() {
  const { t } = useTranslation('method');
  const { ref: headerRef, isVisible: headerVisible } = useScrollReveal({ threshold: 0.15 });
  const { ref: gridRef, isVisible: gridVisible } = useScrollReveal({ threshold: 0.1 });

  const items = t('differentials.items', { returnObjects: true }) as Array<{
    icon: string;
    title: string;
    text: string;
  }>;

  return (
    <section className="py-28 px-6 bg-[#FBF8F3]">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className="text-center mb-20">
          <p
            className="text-xs font-semibold tracking-[0.25em] uppercase text-[#F97700] mb-5 transition-all duration-700"
            style={{
              opacity: headerVisible ? 1 : 0,
              transform: headerVisible ? 'translateY(0)' : 'translateY(20px)',
              transitionDelay: '0ms',
            }}
          >
            {t('differentials.label')}
          </p>
          <h2
            className="text-4xl md:text-5xl font-semibold text-[#0B0B0B] leading-[1.1] tracking-tight mb-6 transition-all duration-700"
            style={{
              opacity: headerVisible ? 1 : 0,
              transform: headerVisible ? 'translateY(0)' : 'translateY(24px)',
              transitionDelay: '120ms',
            }}
          >
            {t('differentials.title')}
          </h2>
          <p
            className="text-[#2E2E2E]/70 text-base max-w-xl mx-auto leading-relaxed transition-all duration-700"
            style={{
              opacity: headerVisible ? 1 : 0,
              transform: headerVisible ? 'translateY(0)' : 'translateY(20px)',
              transitionDelay: '240ms',
            }}
          >
            {t('differentials.subtitle')}
          </p>
        </div>

        <div ref={gridRef} className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, i) => (
            <div
              key={i}
              className="group bg-white border border-[#E7E1D9] p-8 hover:border-[#F97700]/40 hover:shadow-lg transition-all duration-500"
              style={{
                opacity: gridVisible ? 1 : 0,
                transform: gridVisible ? 'translateY(0)' : 'translateY(28px)',
                transitionDelay: `${i * 90}ms`,
              }}
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#F97700]/10 text-[#F97700] mb-6 group-hover:bg-[#F97700] group-hover:text-white transition-all duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-[#0B0B0B] mb-3 tracking-tight">
                {item.title}
              </h3>
              <p className="text-sm text-[#2E2E2E]/75 leading-relaxed">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
